import { faCircleUp as faCircleUpRegular } from '@fortawesome/free-regular-svg-icons'
import { faCircleUp as faCircleUpSolid } from '@fortawesome/free-solid-svg-icons'
import { useState } from 'react'

import EscalationSidebar from '@/components/Escalation/EscalateSidebar'
import IconButton from '@/components/IconButton'
import type { Applicant } from '@/lib/apollo/query/get-applicant'

interface Props {
  applicant: Applicant
  onApplicantUpdated: () => void
}

const Escalation = ({ applicant, onApplicantUpdated }: Props) => {
  const [escalationSidebarOpen, setEscalationSidebarOpen] = useState(false)

  const isEscalated = applicant.escalation !== null

  return (
    <>
      <IconButton
        tooltipMessage={
          isEscalated ? 'Applicant already escalated' : 'Escalate this applicant'
        }
        icon={isEscalated ? faCircleUpSolid : faCircleUpRegular}
        onClick={() => setEscalationSidebarOpen(true)}
        disabled={isEscalated}
      />
      <EscalationSidebar
        isOpen={escalationSidebarOpen}
        subjectId={applicant.id}
        onClose={() => setEscalationSidebarOpen(false)}
        onApplicantUpdated={onApplicantUpdated}
      />
    </>
  )
}

export default Escalation
